import { AxiosResponse } from 'axios';

import { StatusPageLoader } from 'components/statusPage/statusPageLoader';
import { Incident, RawIncident } from 'components/statusPage/types';
import {
  ACTIVE_MAINTENANCE_STATUSES,
  parseIncident
} from 'components/statusPage/utils';

export class ScheduledMaintenancesLoader extends StatusPageLoader {
  public data: Incident[] = [];

  protected parseResponseData(response: AxiosResponse): Incident[] {
    const maintenances = (response.data.scheduled_maintenances || []).map(
      (maintenance: RawIncident) => parseIncident('maintenance', maintenance)
    );
    return this.getFilteredIncidents(maintenances, ACTIVE_MAINTENANCE_STATUSES);
  }
}
